import { useTranslation } from "react-i18next"
import UserMenu from './UserMenu'
import { useAuth } from '../auth/useAuth'

export default function Menu() {
	const { t } = useTranslation()
	const { clientauth } = useAuth()

	return (
		<div className='cabecera d-flex justify-content-between align-items-center px-4 sticky-top'>
			<h5 className='fw-bold text-dark mb-0'>{clientauth?.rol === 'parent' ? t('global.portalparent') : t('global.portal')}</h5>
			<UserMenu />
		</div>
	)
}
